export default __webpack_public_path__ + "static/media/2034.faf18fea.png";